
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-64a6d0a1&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./new-vehicle.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./new-vehicle.js"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-64a6d0a1!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./new-vehicle.vue"),
  /* scopeId */
  "data-v-64a6d0a1",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/vehicle/new-vehicle.vue
// module id = 1962
// module chunks = 1